import { createApp } from "vue";
import { router } from "./router";
import store from "./store/index.js";
import { api, apiPlugin } from "./plugins/api.js";
import App from "./App.vue";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/reset.css";
import "@/assets/css/main.less";

import BaseContainer from "@/components/ui/container/BaseContainer.vue";

const initApp = async () => {
  try {
    const res = await api.post("/users/refresh");
    store.commit("setUser", res.data.data.user);
    store.commit("auth/setAccessToken", res.data.data.accessToken);
  } catch (err) {
    store.commit("setUser", null);
    store.commit("auth/setAccessToken", null);
  }

  const app = createApp(App);

  app.use(router);
  app.use(store);
  app.use(apiPlugin);
  app.use(Antd);

  app.component("BaseContainer", BaseContainer);

  app.mount("#app");
};

initApp();
